import ViewTable from "modules/DeclareLeave/components/CustomTable";

import { Box, Tooltip, Typography } from "@mui/material";
import pxToRem from "theme/base/pxToRem";

import { useDispatch, useSelector } from "react-redux";
import {
  selectListArriveLateData,
  selectListReasonArriveLate,
} from "modules/DeclareLeave/redux/selector";
import { useDialog, useLegacyEffect } from "helper/customHook";
import {
  ApproveStatus,
  ApproveStatusValue,
  statusColor,
} from "modules/DeclareLeave/components/CustomCalendarTimeKeeping/const";
import { DIALOG } from "helper/enum/dialogEnum";
import ArriveLateDetails from "modules/DeclareLeave/components/CustomCalendarTimeKeeping/components/Modals/ArriveLateDetail";
import {
  getListArriveLateDetailStart,
  resetListArriveLateDetail,
  setArriveLateDetailId,
} from "modules/DeclareLeave/redux/getArriveLateDetail";
import { PopoverAction } from "./PopoverAction";
import EmptyState from "components/common/EmptyState";
import { ConfirmModal } from "components/common/ConfirmModal";
import {
  deleteRequestStart,
  setDeleteRequestData,
} from "modules/DeclareLeave/redux/deleteRequest";
import { getReasonArriveLateStart } from "modules/DeclareLeave/redux/getReasonArriveLate";
import { formatDateStringToDDMMYYYY } from "helper/utils";
import { SCREEN } from "helper/roleChecker/Screens";
import { getListArriveLateConfigStart } from "modules/DeclareLeave/redux/getListArriveLateConfig";
import { formReqArrivingLateLeaveEarlyReset } from "modules/DeclareLeave/redux/formReqArrivingLateLeaveEarly";
import { useNavigate, useParams } from "react-router-dom";
import pathRoutes from "routes/pathRoutes";
import { declareLeaveURL } from "modules/DeclareLeave/Pages/Main/DeclareLeaveContent/index";
import { memo } from "react";

export const ListArriveLate = memo(() => {
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const requestLeaveDialog = useDialog(
    DIALOG.VIEW_REQUEST_ARRIVING_LATE_LEAVING_EARLY_DETAIL
  );

  const approveDialog = useDialog(DIALOG.MODAL_CONFIRM);

  const requestArrivingLateDialog = useDialog(
    DIALOG.REQUEST_ARRIVING_LATE_LEAVING_EARLY
  );
  const data = useSelector(selectListArriveLateData);
  const listReasonArriveLate = useSelector(selectListReasonArriveLate);

  const columns = [
    {
      id: "index",
      accessorKey: "index",
      header: "STT",
      width: 50,
      cell: (info) => (
        <Typography
          sx={(theme) => ({
            fontSize: pxToRem(12),
            color: theme.palette.text.textPrimary,
            width: "100%",

            textAlign: "center",
          })}
        >
          {info.row.index + 1 < 10
            ? `0${info.row.index + 1}`
            : info.row.index + 1}
        </Typography>
      ),
      footer: (props) => props.column.id,
      pinPosition: "left",
    },
    {
      id: "registerDate",
      accessorKey: "registerDate",
      header: "Ngày tạo đơn",
      cell: (info) => (
        <Typography
          sx={(theme) => ({
            fontSize: pxToRem(12),
            color: theme.palette.text.textPrimary,
            width: "100%",
            textAlign: "center",
          })}
        >
          {formatDateStringToDDMMYYYY(info.getValue())}
        </Typography>
      ),
      footer: (props) => props.column.id,
      minSize: 125,
      pinPosition: "left",
    },
    {
      id: "type",
      accessorKey: "type",
      header: "Loại",

      cell: (info) => {
        const listType = (info.getValue() ?? "").split("#") ?? [];
        return (
          <Box display={"flex"} flexDirection={"column"}>
            {listType.map((type, index) => (
              <Typography
                key={index}
                sx={(theme) => ({
                  fontSize: pxToRem(12),
                  color: theme.palette.text.textPrimary,
                })}
              >
                {type}
              </Typography>
            ))}
          </Box>
        );
      },
      footer: (props) => props.column.id,
      minSize: 120,
      enablePinning: true,
      pinPosition: "right",
    },
    {
      accessorKey: "dayOffs",
      header: () => "Thời gian",
      footer: (props) => props.column.id,
      cell: (info) => {
        const dayOffs = (info.getValue() ?? "").split("#") ?? [];
        return (
          <Box display={"flex"} flexDirection={"column"}>
            {dayOffs.map((type, index) => (
              <Typography
                key={index}
                sx={(theme) => ({
                  fontSize: pxToRem(12),
                  color: theme.palette.text.textPrimary,
                })}
              >
                {type}
              </Typography>
            ))}
          </Box>
        );
      },
      minSize: 230,
    },
    {
      accessorKey: "totalMinutes",
      header: () => <span>Số phút</span>,
      footer: (props) => props.column.id,
      cell: (info) => (
        <Typography
          sx={(theme) => ({
            fontSize: pxToRem(12),
            color: theme.palette.text.textPrimary,
            width: "100%",
            textAlign: "center",
          })}
        >
          {info.getValue()}
        </Typography>
      ),
      minSize: 90,
    },
    {
      accessorKey: "reason",
      header: "Lý do đi muộn/về sớm",
      cell: (info) => {
        const reasons = (info.getValue() ?? "").split("#") ?? [];
        return (
          <Box
            display={"flex"}
            flexDirection={"column"}
            alignItems={"flex-end"}
          >
            {reasons.map((type, index) => (
              <Typography
                key={index}
                sx={(theme) => ({
                  fontSize: pxToRem(12),
                  color: theme.palette.text.textPrimary,
                })}
              >
                {listReasonArriveLate.find((i) => i.value === type)?.label}
              </Typography>
            ))}
          </Box>
        );
      },
      footer: (props) => props.column.id,
      minSize: 180,
    },
    {
      accessorKey: "relatedPersonName",
      header: "Người liên quan",
      footer: (props) => props.column.id,
      minSize: 150,
    },
    {
      accessorKey: "approveName",
      header: "Người duyệt",
      footer: (props) => props.column.id,
      minSize: 150,
    },
    {
      id: "modifiedDate",
      accessorKey: "modifiedDate",
      header: "Ngày cập nhật đơn",
      cell: (info) => (
        <Typography
          sx={(theme) => ({
            fontSize: pxToRem(12),
            color: theme.palette.text.textPrimary,
            width: "100%",
            textAlign: "center",
          })}
        >
          {info.getValue() ? formatDateStringToDDMMYYYY(info.getValue()) : ""}
        </Typography>
      ),
      footer: (props) => props.column.id,
      minSize: 155,
      pinPosition: "left",
    },
    {
      accessorKey: "note",
      header: "Lý do chi tiết",
      minSize: 180,
      cell: (info) => (
        <Tooltip title={info?.getValue()}>
          <Typography
            sx={{
              fontSize: pxToRem(12),
              overflow: "hidden",
              textOverflow: "ellipsis",
              height: pxToRem(60),
              textAlign: "left",
              wordWrap: "break-word",
            }}
          >
            {info?.getValue()?.length > 60
              ? `${info?.getValue()?.slice(0, 60)}...`
              : info?.getValue()}
          </Typography>
        </Tooltip>
      ),
      footer: (props) => props.column.id,
    },
    {
      accessorKey: "refuseReason",
      header: "Lý do phê duyệt",
      footer: (props) => props.column.id,
      minSize: 150,
    },
    {
      accessorKey: "status",
      header: "Trạng thái",
      footer: (props) => props.column.id,
      cell: (info) => {
        const status = info.getValue();
        return (
          <Typography
            sx={(theme) => ({
              fontSize: pxToRem(12),
              fontWeight: 600,
              color: statusColor(theme, status, "color"),
              width: "100%",
              textAlign: "center",
            })}
          >
            {ApproveStatus[status]}
          </Typography>
        );
      },
      minSize: 100,
    },
    {
      accessorKey: "action",
      header: "",
      cell: (info) => (
        <PopoverAction
          showAction={[
            ApproveStatusValue.PENDING,
            ApproveStatusValue.APPROVE,
            ApproveStatusValue.AUTO_APPROVE,
          ].includes(info.row.original.status)}
          editable={info.row.original.editable}
          isDeletable={info.row.original.delete}
          isCancelable={info.row.original.cancel}
          editAction={(e) => {
            e.stopPropagation();
            const month = (info.row.original.dayOffs ?? "")
              .split("#")[0]
              .split("/")[1];
            const year = info.row.original.dayOffs
              .split("đến ")[0]
              .split("/")
              .pop();

            dispatch(
              getListArriveLateConfigStart({
                month,
                year,
                screenCode: SCREEN.IP_016,
              })
            );
            dispatch(setArriveLateDetailId(info.row.original.id));
            dispatch(
              getListArriveLateDetailStart({
                screenCode: SCREEN.IP_016,
                id: info.row.original.id,
              })
            );

            requestArrivingLateDialog.open();
          }}
          deleteAction={(e) => {
            dispatch(setDeleteRequestData(info.row.original.id));
            e.stopPropagation();
            approveDialog.open();
          }}
          // TODO
          cancelAction={(e) => {
            e.stopPropagation();
            dispatch(
              getListArriveLateDetailStart({
                screenCode: SCREEN.IP_016,
                id: info.row.original.id,
              })
            );
            approveDialog.open();
          }}
        />
      ),

      minSize: 60,
    },
  ];

  const deleteRequest = () => {
    approveDialog.close();
    dispatch(formReqArrivingLateLeaveEarlyReset());
    dispatch(resetListArriveLateDetail());
    dispatch(deleteRequestStart({ tab: "late", screenCode: SCREEN.IP_016 }));
  };

  useLegacyEffect(() => {
    if (listReasonArriveLate.length === 0) {
      dispatch(getReasonArriveLateStart());
    }
  }, []);

  const handleViewDetail = (idRecord: string) => {
    if (idRecord === id) {
      requestLeaveDialog.open();
    } else {
      navigate(
        `${pathRoutes.declareLeave.base}/${declareLeaveURL.orderLeave}/${declareLeaveURL.lackOfTime}/${idRecord}`,
        { replace: true }
      );
    }
  };

  return (
    <>
      <ViewTable
        data={data ?? []}
        columns={columns}
        columnPinning={{
          left: [],
          right: ["action"],
        }}
        handleFetchMore={() => {}}
        messageEmpty={
          <EmptyState
            message="Chưa có đơn xin đi muộn/về sớm nào"
            sx={(theme) => ({
              h6: {
                color: theme.palette.text.textSecondary,
              },
            })}
          />
        }
        handleOnClickedRow={(item) => {
          handleViewDetail(item.id);
        }}
        height={"auto"}
      />
      <ArriveLateDetails />
      <ConfirmModal
        title="Bạn có muốn xóa đơn này"
        styleTitle={{
          width: pxToRem(270),
        }}
        buttonApprove="Xóa đơn"
        buttonReject="Hủy"
        buttonApproveProps={{
          color: "error",
        }}
        buttonRejectProps={{
          variant: "blur",
          sx: {
            backgroundColor: "#E6E6E6",
            color: "#000000",
          },
        }}
        onApprove={deleteRequest}
      />
    </>
  );
});
